<span *ngIf="visibility"
  class="tooltip" [attr.data-au]="'tooltip'"
  [class.show]="visibility"
>{{text}}</span>
